/* eslint-disable */

const pad = i => i < 10 ? `00${i}` : i < 100 ? `0${i}` : `${i}`;

const isMobile = window.innerWidth < 1024;

const instances = [];

const getScrollProgress = () => {
  const scrollPosition = window.scrollY || document.documentElement.scrollTop;
  const totalScroll = document.body.clientHeight;
  return scrollPosition / totalScroll;
}

const renderLoop = function(){
  const progress = getScrollProgress();
	for( var i = 0; i < instances.length; i++ ){
    const instance = instances[i];
    const activeIndex = Math.floor(progress * instance.frameImgs.length);
		instance.setActiveIndex(activeIndex);
	}
	requestAnimationFrame(renderLoop);
};
renderLoop();


function PlayOnScroll(el) {

  const {
    frameUrlTemplate = '{{index}}.jpg',
  } = el.dataset;
  const padIndexes = 'padIndexes' in el.dataset;
  const numberOfFrames = el.dataset[isMobile ? 'numberOfFramesMobile' : 'numberOfFrames']

  const getFrameUrl = index => frameUrlTemplate.replace('{{index}}', padIndexes ? pad(index + 1) : index + 1);

  // create image elements for every frame in DOM
  const div = document.createElement('div');
  el.parentElement.insertBefore(div, el);
  el.style.display = 'none';
  this.frameImgs = [];
  for (let i = 0; i < numberOfFrames; i++) {
    const image = document.createElement('img');
    div.appendChild(image);
    this.frameImgs.push(image);
    if (i === 0) {
      image.addEventListener('load', () => {
        div.classList.add('play-on-scroll-ready');
      })
    } else {
      image.style.visibility = 'hidden';
    }
    image.src = getFrameUrl(i);
    image.alt = '';
  }

  // first frame is loaded and displayed by default
  this.activeIndex = 0;

  // load images consecutively
  // const loadAtIndex = (i) => {
  //   const image = this.frameImgs[i];
  //   if (!image) return;
  //   image.addEventListener('load', () => {
  //     loadAtIndex(i + 1)
  //   });
  //   image.src = getFrameUrl(i);
  // }
  // loadAtIndex(1);


  instances.push( this );
}


PlayOnScroll.prototype.setActiveIndex = function(activeIndex) {
  if (activeIndex === this.activeIndex) return;
  if (!this.frameImgs[activeIndex]) return;
  const oldActiveIndex = this.activeIndex;
  if (!this.frameImgs[oldActiveIndex]) return;
  this.activeIndex = activeIndex;
  this.frameImgs[oldActiveIndex].style.visibility = 'hidden';
  this.frameImgs[activeIndex].style.visibility = 'visible';
}


export default PlayOnScroll
